export const columns = function () {
    return [
        {
            prop: 'insBillId',
            label: '服务单流水号',
            minWidth: 200,
            fixed: 'left'
        },
        {
            prop: 'carNo',
            label: '车牌号',
            minWidth: 100,
        },
        {
            prop: 'status',
            label: '状态',
            minWidth: 100,
            render: ({ status }) => {
                return (this.$emun.status.find(item => item.value === status)).label || '-'
            }
        },
        {
            prop: 'b_personName',
            label: '被服务人',
            sortable: true,
            minWidth: 150,
        },
        // {
        //     prop: 'beginTime',
        //     label: '服务起期',
        //     sortable: true,
        //     minWidth: 150,
        // },
        // {
        //     prop: 'endTime',
        //     label: '服务止期',
        //     sortable: true,
        //     minWidth: 150,
        // },
        {
            prop: 'carType',
            label: '车型',
            sortable: true,
            minWidth: 150,
        },
        {
            prop: 'contractFee',
            label: '标准服务费',
            minWidth: 100,
        },
        {
            prop: 'cusRebate',
            label: '整单折扣',
            minWidth: 100,
        },
        {
            prop: 'cusFee',
            label: '应交服务费',
            minWidth: 100,
        },
        {
            prop: 'customerRebate',
            label: '客户折扣',
            minWidth: 100,
        },
        {
            prop: 'customerFee',
            label: '客户服务费',
            minWidth: 100,
        },
        {

            prop: 'orgName',
            label: '出单机构',
            minWidth: 150,
        },
        {
            prop: 'auditName',
            label: '核审人',
            sortable: true,
            minWidth: 200,
        },
        {
            prop: 'auditTime',
            label: '核审时间',
            sortable: true,
            minWidth: 200,
        },
        {
            prop: 'auditRemark',
            label: '核审意见',
            minWidth: 200,
        },
        {
            prop: 'handle',
            label: '操作',
            fixed: 'right',
            minWidth: 250
        }
    ]
}

export default {}